module.exports = __webpack_public_path__ + "static/img/dice_3.21357de.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/lottery/dice/dice_3.png
// module id = 4pZP
// module chunks = 23